import "./index.css";
import "./polyfills";
import App from "./svelte/app.svelte";

new App({
  target: document.querySelector('#app'),
});
